import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"

import { LOCAL_STORAGE_SHOW_PACKAGE_EXPIRED } from "const"
import * as routes from "client/parts/routes"
import {
    StoreType,
    LangType,
    PackageAlmostExpireTime,
} from "client/store"
import { forceRerenderContent } from "client/utils"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
} from "client/components"


const packageAlmostExpireTime = PackageAlmostExpireTime()


const PackageExpiredNotification = () => {
    const activePackage = useSelector((state: StoreType) => state.system.packageActive)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const showPackageExpired = window.localStorage.getItem(LOCAL_STORAGE_SHOW_PACKAGE_EXPIRED) !== "false"
    const [showNotification, setShowNotification] = useState<boolean>(showPackageExpired)

    if (!activePackage) return null

    const onClose = () => {
        window.localStorage.setItem(LOCAL_STORAGE_SHOW_PACKAGE_EXPIRED, "false")
        setShowNotification(false)
    }

    const onRedirect = () => {
        forceRerenderContent(routes.mtBillingRoute, dispatch)
        setShowNotification(false)
    }

    const packageExpireDate = new Date(activePackage.dateEnd)
    const packageExpireTime = packageExpireDate.getTime()
    const now = new Date().getTime()
    const almostExpired = packageExpireTime > now && packageExpireTime - now <= packageAlmostExpireTime
    const expired = packageExpireTime <= now

    const year = packageExpireDate.getFullYear()
    const month = lang[`month_${packageExpireDate.getMonth()}` as keyof LangType]
    const day = packageExpireDate.getDate().toString()
    const expireDate = `${month} ${day}, ${year}`

    let title = ""
    let description: string
    if (almostExpired) {
        title = lang.subscriptionExpires
        description = lang.subscriptionExpiresDescription
    }
    if (expired) {
        title = lang.subscriptionExpired
        description = lang.subscriptionExpiredDescription
    }
    title = title.replace("{0}", expireDate.toString())

    return (
        <ConfirmWrapper
            show={showNotification && (almostExpired || expired)}
            onClose={onClose}
        >
            <Confirm>
                <ConfirmTitle>{title}</ConfirmTitle>
                <ConfirmDescription>{description}</ConfirmDescription>

                <ConfirmBottom>
                    { !expired && <Button row onClick={onClose}>{lang.remindMeLater}</Button> }
                    <Button variant="success" row onClick={onRedirect}>{lang.selectPackage}</Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default PackageExpiredNotification
